var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49996 11.0835L8.79285 11.7906L9.49996 12.4977L10.2071 11.7906L9.49996 11.0835ZM10.5 3.9585C10.5 3.40621 10.0522 2.9585 9.49996 2.9585C8.94768 2.9585 8.49996 3.40621 8.49996 3.9585L10.5 3.9585ZM4.83452 7.83227L8.79285 11.7906L10.2071 10.3764L6.24873 6.41806L4.83452 7.83227ZM10.2071 11.7906L14.1654 7.83227L12.7512 6.41806L8.79285 10.3764L10.2071 11.7906ZM10.5 11.0835L10.5 3.9585L8.49996 3.9585L8.49996 11.0835L10.5 11.0835Z",
    fill: "#8F9BBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95837 12.6665L3.95837 13.4582C3.95837 14.3326 4.66726 15.0415 5.54171 15.0415L13.4584 15.0415C14.3328 15.0415 15.0417 14.3326 15.0417 13.4582V12.6665",
    stroke: "#8F9BBC",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.f749a17c2040e4325af34258f668b6d4.svg";
export { ForwardRef as ReactComponent };